import React from "react";
import PatientfeedBack from "./Components/PatientfeedBack";
export default function Feedback(){
    return (

        <PatientfeedBack />

    )
}